import { useSelector } from 'react-redux'

import type { PartnerType } from '../../types/partner'

type PartnerAccountSlice = {
  partnerData?: {
    partnerId?: string
    authProtocol?: string
  }
  isLoading?: boolean
  error?: unknown
}

type UsePartnerRootState = {
  AccountData?: Partial<Record<PartnerType, PartnerAccountSlice>>
}

export const usePartner = (partnerId: string, partnerType: PartnerType) => {
  const accountSlice = useSelector(
    (state: UsePartnerRootState) => state.AccountData?.[partnerType]
  )
  const partnerData = accountSlice?.partnerData

  if (partnerData?.partnerId !== partnerId) {
    return {
      isLoading: accountSlice?.isLoading ?? true,
      error: accountSlice?.error ?? null,
      partnerData: null,
    }
  }

  return {
    partnerData,
    loading: accountSlice?.isLoading ?? false,
    error: accountSlice?.error ?? null,
  }
}
